import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';

/**
 * Service de feedback
 */
@Injectable({
    providedIn: 'root'
})
export class FeedbackService {

    /**
     * Constructeur
     * @param http
     */
    constructor(private http: HttpClient) {
    }

    /**
     * Envoyer un feedback 
     */
    envoyerFeedback(message: string) {
        let modele = {
            Message: message
        };
        return this.http.post(`api/feedback/envoyerfeedback`, modele).pipe(map((retour: any): any => { return retour }));
    }
}
